import React from 'react';
import 'twin.macro';
import { Link } from 'gatsby';

import { Heading, Subtitle, Container, Button } from '../atoms';
import SanityImage from '../global/SanityImage';

// const Wrapper = styled.div(() => [tw`flex`]);

const InfoBlock = (props) => {
  const { description, image, title, linkTo } = props;
  return (
    <Container tw="bg-slate">
      <div tw="flex flex-col md:flex-row rounded items-center">
        <div tw="md:w-1/3 overflow-visible relative">
          {image.asset && (
            <SanityImage
              gatsbyImageId={image.asset.id}
              alt={title || 'spas and hot tubs'}
              width={800}
              tw="shadow-lg"
            />
          )}
        </div>

        <div tw="md:w-2/3 p-6	md:p-16 bg-green">
          <Heading tw="text-white">{title}</Heading>
          <Subtitle tw="text-white">{description}</Subtitle>
          <Link to={(linkTo && linkTo.current) || '/'}>
            <Button variant="secondary">Learn more</Button>
          </Link>
        </div>
      </div>
    </Container>
  );
};

export default InfoBlock;
